import { useMutation } from "react-query";

import { LoyaltyApi } from "../../../services";

export type SubmitContestRequestBody = {
  contest: Array<{
    question?: string;
    answers?: Array<string>;
  }>;
  files?: Array<Blob | File>;
  contest_id: string;
};

type HandleStartContestParams = {
  uuid: string;
  ciam_token: string;
  formData: SubmitContestRequestBody;
};

export const useSubmitContest = () =>
  useMutation<void, Error, HandleStartContestParams>(({ uuid, ciam_token, formData }) =>
    LoyaltyApi.init().postContest(uuid, ciam_token, formData)
  );
